/*
 * @Description:
 * @Date: 2020-10-14 15:58:13
 */
//入口
// import { order } from '../../api';
// import importAll from '@/tools/importAll';
// const children  = importAll(require.context('./'))

import { orderManagement } from '@/api/ajax';
import fields from '@/page/settlementCenter/projectSettled/common/fields.js';
import search from '@/page/settlementCenter/projectSettled/common/search.js';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import _fields from './fields.js';
import { PAY_BANK_TYPE_KEY, PAY_TYPE_KEY } from '@/common/constants/bank';

const example = new TableRenderClass({
  fields: { ...fields, ..._fields },
  search
});
const part = example.createPart({
  name: '订单支付进度列表',
  list: orderManagement.listPaySchedule,
  requestNow: true,
  search: ['xiangmucanyuren', 'shoujihao', 'zhifuzhuangtai', PAY_BANK_TYPE_KEY],
  fields: [
    'index',
    'xiangmucanyuren',
    'zhifujindu_shoujihao',
    'shoukuanzhanghao',
    'xiangmumingcheng',
    'finishSum',
    'taskPrice',
    'zhongduanjiesuanjine',
    'serviceScale',
    'totalPrice',
    'payStatus',
    'finishPayDt',
    'finishGetPayDt',
    PAY_BANK_TYPE_KEY,
    PAY_TYPE_KEY
  ]
});

export default [{ name: '订单支付进度列表', childMenu: [part] }];
